import { render, staticRenderFns } from "./DistributeRecord.vue?vue&type=template&id=313cb876&"
import script from "./DistributeRecord.vue?vue&type=script&lang=js&"
export * from "./DistributeRecord.vue?vue&type=script&lang=js&"
import style0 from "./DistributeRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports